import { Directive , ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[AllowNumberOnly]'
})
export class AllowNumberOnlyDirective {

  // Updated regex to allow numbers and decimal points
  DIGITS_REGEXP = new RegExp(/[^\d.]/g);
  
  constructor(private el: ElementRef) { 

      // Sanatize clipboard by removing any non-numeric input after pasting
      this.el.nativeElement.onpaste = (e:any) => {
          e.preventDefault();
          let text;
          let clp = (e.originalEvent || e).clipboardData;
          if (clp === undefined || clp === null) {
              text = (<any>window).clipboardData.getData('text') || '';
              if (text !== '') {
                  text = text.replace(this.DIGITS_REGEXP, '');
                  // Remove multiple decimal points, keeping only the first one
                  text = this.removeMultipleDecimals(text);
                  if (window.getSelection) {
                      let newNode = document.createElement('span');
                      newNode.innerHTML = text;
                      window.getSelection().getRangeAt(0).insertNode(newNode);
                  } else {
                      (<any>window).selection.createRange().pasteHTML(text);
                  }
              }
          } else {
              text = clp.getData('text/plain') || '';
              if (text !== '') {
                  text = text.replace(this.DIGITS_REGEXP, '');
                  // Remove multiple decimal points, keeping only the first one
                  text = this.removeMultipleDecimals(text);
                  document.execCommand('insertText', false, text);
              }
          }
      };
  }

  // Helper method to remove multiple decimal points
  private removeMultipleDecimals(text: string): string {
    const parts = text.split('.');
    if (parts.length > 2) {
      return parts[0] + '.' + parts.slice(1).join('');
    }
    return text;
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent> event;
    
    // Allow: backspace, delete, tab, escape, enter, decimal point (both . and ,)
    if ([46, 8, 9, 27, 13, 110, 190, 188].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      
      // Special handling for decimal point
      if (e.keyCode === 190 || e.keyCode === 188) { // . or ,
        const currentValue = this.el.nativeElement.value;
        const cursorPosition = this.el.nativeElement.selectionStart;
        
        // Check if there's already a decimal point in the current value
        if (currentValue.includes('.')) {
          e.preventDefault();
          return;
        }
      }
      
      // let it happen, don't do anything
      return;
    }
    
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1465393655/src/src/app/shared/directive/allow-number-only.directive.ts